module.exports = __webpack_public_path__ + "img/logo.03f21ecf.svg";